import React from "react";
import Effert from "../EffSection/Effert";
import U1 from "../../Images/New/Verification/u1.png"
import U2 from "../../Images/New/Verification/u2.png"
import U3 from "../../Images/New/Verification/u3.png"

const Verification = () => {
  const sections = [
    {
      title: "PAN",
      description:
        "Bulk PAN verification along with verification status & option to update names as per PAN",
    },
    {
      title: "TAN",
      description:
        "Verification of TAN and update Deductor Name as per TAN in Assessee master",
    },
    {
      title: "Challan",
      description:
        "Facility to verify challan details added in the software with the data available with the department",
    },
  ];

  return (
    <div className="relative bg-white py-10 px-3 flex justify-center">
      <div className="w-full max-w-7xl sm:px-8">
        <div className="my-10">
          <Effert />
        </div>
        <div>
          <div className="text-center mb-10">
            <p className="mb-0 text-black text-4xl font-bold">
              PAN, TAN & Challan{" "}
              <span
                style={{
                  backgroundImage:
                    "linear-gradient(120deg, #686bff 0%, #00b812 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                }}
              >
                Verification
              </span>
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 p-3 gap-x-4 gap-y-5 sm:gap-y-0">
            {sections.map(({ title, description }) => (
              <div
                key={title}
                className="bg-[#b5d0ff] bg-opacity-20 p-5 border-2 border-[#b5d0ff] text-center rounded-xl duration-200 hover:shadow-2xl"
              >
                <p className="mb-5 text-black text-2xl font-bold">
                  {title} Verification
                </p>
                <div className="flex items-start">
                  <p className="mb-0 text-black text-xl font-medium">
                    {description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="my-10">
          <div className="text-center">
            <p className="mb-0 text-black text-4xl font-bold">
              Utilities & more
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 p-3 gap-x-4 gap-y-5 sm:gap-y-0">
            <div className="bg-[#ffffff] py-5 px-5 rounded-lg group border border-[#b5d0ff] hover:scale-105 duration-150 hover:shadow-lg ">
              <div className="flex flex-col justify-center items-center">
                <img src={U1} className="w-14 mr-4 mb-2" alt="" />
                <div>
                  <p className="mb-0 text-xl text-center font-semibold text-[#2a3742] group-hover:text-blue-700">
                    Advanced online tools perform complex tasks and enhance user
                    experiences.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-[#ffffff] py-5 px-5 rounded-lg group border border-[#b5d0ff] hover:scale-105 duration-150 hover:shadow-lg ">
              <div className="flex flex-col justify-center items-center">
                <img src={U2} className="w-14 mr-4 mb-2" alt="" />
                <div>
                  <p className="mb-0 text-xl text-center font-semibold text-[#2a3742] group-hover:text-blue-700">
                    Access TRACES, PROTEAN & Income Tax websites through the
                    software
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-[#ffffff] py-5 px-5 rounded-lg group border border-[#b5d0ff] hover:scale-105 duration-150 hover:shadow-lg ">
              <div className="flex flex-col justify-center items-center">
                <img src={U3} className="w-14 mr-4 mb-2" alt="" />
                <div>
                  <p className="mb-0 text-xl text-center font-semibold text-[#2a3742] group-hover:text-blue-700">
                    Convenient & systematic data entry with user-friendly
                    interfaces
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="my-10">
          <div className="text-center">
            <p className="mb-5 text-black text-4xl font-bold">
              Software update tools
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 p-3 gap-x-4 gap-y-5 sm:gap-y-0">
            <div className="bg-[#ffffff] py-5 px-5 rounded-lg group border border-[#b5d0ff] hover:scale-105 duration-150 hover:shadow-lg ">
              <div className="flex flex-col justify-center items-center">
                <img src={U1} className="w-14 mr-4 mb-2" alt="" />
                <div>
                  <p className="mb-0 text-xl text-center font-semibold text-[#2a3742] group-hover:text-blue-700">
                    Download Update
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-[#ffffff] py-5 px-5 rounded-lg group border border-[#b5d0ff] hover:scale-105 duration-150 hover:shadow-lg ">
              <div className="flex flex-col justify-center items-center">
                <img src={U2} className="w-14 mr-4 mb-2" alt="" />
                <div>
                  <p className="mb-0 text-xl text-center font-semibold text-[#2a3742] group-hover:text-blue-700">
                    Auto-update Installer
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-[#ffffff] py-5 px-5 rounded-lg group border border-[#b5d0ff] hover:scale-105 duration-150 hover:shadow-lg ">
              <div className="flex flex-col justify-center items-center">
                <img src={U3} className="w-14 mr-4 mb-2" alt="" />
                <div>
                  <p className="mb-0 text-xl text-center font-semibold text-[#2a3742] group-hover:text-blue-700">
                    Web-update reminder
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verification;
